import { Skeleton } from "@/modules/common/components";

const LogDetailsSkeleton = () => {
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Skeleton className="h-3 w-48" />
        <div className="flex items-center justify-between gap-4">
          <Skeleton className="h-7 w-72" />
          <Skeleton className="h-11 w-28 rounded-lg" />
        </div>
        <Skeleton className="h-4 w-96" />
      </div>

      <div className="flex flex-col gap-4 rounded-xl bg-white p-4">
        <Skeleton className="h-4 w-40" />
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="flex flex-col gap-1">
              <Skeleton className="h-3 w-24" />
              <Skeleton className="h-11 w-full rounded-lg" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogDetailsSkeleton;
